<template>
  <div class="instruction">
    <el-drawer title="质控规则" :visible.sync="drawerSon" :modal="modal" direction="ltr" :before-close="handleClose" size="25%">
      <div class="drawer-container">
        <el-tabs v-model="tabActiveName" @tab-click="handleTabSelect" >
          <el-tab-pane label="通用规则" name="0">
            <div v-if="ruleList!=[]">
              <div v-for="(item,index) in ruleList" :key="index" class="rule-item">
                  <span>【{{item.ruleTypeName}}】</span><span>{{index+1}}、{{item.ruleName}}</span>
              </div>
            </div>
            <div v-else>
              <span class="no-data">
                  <img src="./img/no-result.png" alt="暂无质控规则">
                  <p>暂无质控规则</p>
              </span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="本任务规则" name="1">
            <div v-if="ruleList!=[]">
              <div v-for="(item,index) in ruleList" :key="index" class="rule-item">
                  <span>【{{item.ruleTypeName}}】</span><span>{{index+1}}、{{item.ruleName}}</span>
              </div>
            </div>
            <div v-else>
              <span class="no-data">
                  <img src="./img/no-result.png" alt="暂无质控规则">
                  <p>暂无质控规则</p>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  RestFeedbackOutControllerGetQualityRule, //获取质控规则
} from "@src/assets/js/api.js";
export default {
  name: "RuleInstruction",
  props: ["drawerSon","followupTaskId"],
  data() {
    return {
      modal: false,
      drawer:this.drawerSon,
      tabActiveName: "0",
      ruleList:[],
    };
  },
  components: {},
  mounted() {
    this.onLoad();
  },
  computed: {},
  methods: {
    onLoad() {
      this.getExternalRuleSettingList()
    },
    getExternalRuleSettingList() {
      let data = {
        ruleName: null,
        relationTaskId: this.tabActiveName=="0"?null:this.followupTaskId *1,
        isFather: false,
        fatherId: null,
        isNormal: this.tabActiveName=="0"? 1: 0,
        judgeIsAllRelationTask:this.tabActiveName=="0"? null: 1,
      }
      this.ruleList = []
      this.getExternalRuleListAsync(data)
        .then(res => {
          if (res.status == 0) {
            this.ruleList = res.retValue.map(item => {
              item.ruleTypeName = this.getRuleType(item.ruleType)
              return item;
            })
          }
        })
    },
    handleTabSelect(tab, event){
      this.getExternalRuleSettingList()
    },
    handleClose(done) {
      this.tabActiveName=="0"
      this.$emit('closeDrawer')
    },
    getRuleType(type) {
      switch (type) {
        case 1:
          return '填写'
          break
        case 2:
          return '话术'
          break
        case 3:
          return '操作'
          break
        case 4:
          return '疾病'
          break
      }
    },
    // ====================================
    async getExternalRuleListAsync(p) {
      let request = new RestFeedbackOutControllerGetQualityRule()
      request.p_ruleName = p.ruleName;
      request.p_relationTaskId = p.relationTaskId;
      request.p_isFather = p.isFather;
      request.p_fatherId = p.fatherId;
      request.p_isNormal = p.isNormal;
      request.p_judgeIsAllRelationTask = p.judgeIsAllRelationTask
      await request.send()
      return request.result
    },
  }
};
</script>
<style lang="scss" scoped>
.instruction {
  .drawer-container {
    padding: 0 30px;
    .rule-item {
      border-bottom: 1px solid #ccc;
      padding: 15px 10px;
      margin: 10px 0;
    }
    .no-data {
        p {
            margin: 40px 0 80px;
            font-size: 16px;
            font-weight: bold;
            color: rgba(0, 0, 0, .5);
        }
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        width: 480px;
        height: 80vh;
        padding: 15px 15px 15px 20px;
        box-sizing: border-box;
        margin-top: 20px;
        margin-bottom: 20px;

    }
  }
}
</style>
<style lang="scss">
.instruction {
  .el-drawer__header {
    margin-bottom: 10px;
  }
  .el-tabs__nav {
    width: 100%;
    .el-tabs__item {
      width: 50%;
      text-align: center;
    }
  }
}
</style>

